import { WorkerStore } from 'accountant/worker/src/store';
import { REGISTRATION_STATUS } from '../../workerConstants';
import { BOND_TYPES } from './infoJobConstants';

export function hasWorkInfoDraft() {
  return !!WorkerStore.worker?.workInfo;
}

export function hasInfoJob(workerBasicInfo) {
  const { statusInfo } = workerBasicInfo;

  return REGISTRATION_STATUS[statusInfo].step >= REGISTRATION_STATUS.HAS_WORKER_INFO.step;
}

export function hasBondWithAnotherCompany(value) {
  return value !== BOND_TYPES.NO_BOND;
}
